import React from "react";
import { Box, Typography } from "@mui/material";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AutoResolvedChartView from "./AutoResolvedChartView";
import { PrimaryTooltip } from "../../../Components/StyledComponent";
import { formatDateRange } from "../../../Helper/Analytics/AnalyticsHelper";

const AutoResolvedChart = ({ onDetailsClick, startDate, endDate, hierarchicalLocation, fleetIds, onboardingLocations, allOnboardingLocations, alertCategories, operationalStatus }) => {

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        borderRadius: "8px",
        padding: "24px 22px",
        border: "1px solid #E6E6E6",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <PrimaryTooltip
            title="This chart represents and showcases only those alerts which have been resolved on dates within the chosen time period"
            placement="bottom"
          >
            <Typography
              variant="fw600s16lh24c444B51"
              sx={{ color: "#2E2E2E", "&:hover": { textDecoration: 'underline' } }}
            >
              Fault Resolution Trend (Auto vs Manual)
            </Typography>
          </PrimaryTooltip>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              cursor: "pointer",
              "&:hover": {
                "& .MuiTypography-root": {
                  color: '#4D44D8'
                },
                "& .MuiSvgIcon-root": {
                  color: "#4D44D8",
                },
              }
            }}

            onClick={onDetailsClick}
          >
            <Typography
              variant="fw500s12lh20c000000"
              sx={{ color: "#6D72F6" }}
            >
              Details
            </Typography>
            <ChevronRightIcon sx={{ color: '#6D72F6', fontSize: "18px" }} />
          </Box>
        </Box>
        <Typography variant="fw400s12c686868" sx={{ lineHeight: "20px" }}>
          {formatDateRange(startDate, endDate)}
        </Typography>
      </Box>

      {/* Chart */}
      <AutoResolvedChartView
        startDate={startDate}
        endDate={endDate}
        isSidebarExpanded={false}
        filters={[]}
        hierarchicalLocation={hierarchicalLocation}
        fleetIds={fleetIds}
        onboardingLocations={onboardingLocations}
        allOnboardingLocations={allOnboardingLocations}
        alertCategories={alertCategories}
        operationalStatus={operationalStatus}
      />
    </Box>
  );
};

export default AutoResolvedChart;
